import './App.css';
import Board from './components/Board';

function App() {
  return (
    <div>
      <Board />
    </div>
  );
}

export default App;
